// extracted by mini-css-extract-plugin
export default {"content":"style_content__LnS8F","divider":"style_divider__pbys9","dividerText":"style_dividerText__388oq"};